module.exports = __webpack_public_path__ + "img/event_3.fef22d06.jpg";